var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAccountRemoveOutline = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.095 6.66L2.16 5.595l1.59 1.598 1.59-1.598L6.405 6.66 4.808 8.25l1.597 1.59-1.065 1.065-1.59-1.598-1.59 1.598L1.095 9.84l1.598-1.59-1.598-1.59zM11.25 3a3 3 0 110 6 3 3 0 010-6m0 1.425a1.575 1.575 0 100 3.15 1.575 1.575 0 000-3.15zm0 5.325c2.003 0 6 .998 6 3V15h-12v-2.25c0-2.002 3.998-3 6-3zm0 1.425c-2.25 0-4.575 1.095-4.575 1.575v.825h9.15v-.825c0-.48-2.347-1.575-4.575-1.575z"
  })));
};
export default SvgAccountRemoveOutline;